import React, {useState} from 'react';
import BootstrapTable, {BootstrapTableProps} from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import usePaginatorCentered from "../../../Hooks/Paginator/PaginatorHook";
import {uuidV4} from "../../../Utils/Utils";

export interface Bootstrap4TableProps extends Omit<BootstrapTableProps, 'keyField'> {
  keyField?: string,
  loading?: boolean,
  noReactTableParentClass?: boolean,
}

const Bootstrap4Table: React.FC<Bootstrap4TableProps> = ({
  keyField = "_KEY", loading = false,
  pagination = paginationFactory({sizePerPage: 15, hideSizePerPage: true}),
  noReactTableParentClass = false,
  ...props
}) => {

  const [context] = useState(`pagination_${uuidV4()}`);

  usePaginatorCentered(context, [props.data], noReactTableParentClass);

  return (
    <>
      {
        !loading && props.data.length > 0 &&
        <BootstrapTable
          {...props}
          condensed
          bordered
          keyField={keyField}
          wrapperClasses={context}
          pagination={pagination}
        />
      }
    </>
  );
};

export default Bootstrap4Table;
